import React from "react";
import { useHistory } from "react-router-dom";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import "./home-landing.css";

const PUBLIC = process.env.PUBLIC_URL || "";
const SHOT = (file) => `${PUBLIC}/images/montestory-workspace-images/${file}.png`;
const CLASSROOM_PHOTO = `${PUBLIC}/images/${encodeURIComponent(
  "freepik__the-style-is-candid-image-photography-with-natural__39189 (1).jpeg"
)}`;
const DEMO_VIDEO = "/images/home.mp4?v=20260330_1";

// Floating activity artwork below the headline. Each tile drifts on its own timing.
const TILES = [
  { id: "planner", src: SHOT("01-activity-planner"), cls: "lh-tile--planner" },
  { id: "lesson", src: SHOT("03-lesson-plans"), cls: "lh-tile--lesson" },
  { id: "photo", src: CLASSROOM_PHOTO, cls: "lh-tile--photo" },
  { id: "alphabets", src: SHOT("05-movable-alphabets"), cls: "lh-tile--alphabets" },
  { id: "library", src: SHOT("02-activities"), cls: "lh-tile--library" },
];

const HomeHero = () => {
  const history = useHistory();

  return (
    <section className="lh-hero" aria-label="Montestory">
      <div className="lh-hero__inner">
        <h1 className="lh-title">Montestory runs the daily work of your Montessori school - all in one connected platform.</h1>

        <p className="lh-tagline">Plan · Track · Connect · Grow</p>

        <p className="lh-lead">
          Montestory runs your Montessori school's day: activities, lessons, attendance, fees, and a parent app
          parents actually use.
        </p>

        <div className="lh-cta">
          <button type="button" className="lh-btn lh-btn--primary" onClick={() => history.push("/montessori/schoolregistration")}>
            Start your free trial <ArrowForwardIcon fontSize="small" />
          </button>
          <a className="lh-btn lh-btn--ghost" href={DEMO_VIDEO} target="_blank" rel="noopener noreferrer">
            <PlayArrowIcon fontSize="small" /> Watch demo
          </a>
        </div>
      </div>

      <div className="lh-stage" aria-hidden="true">
        {TILES.map(({ id, src, cls }) => (
          <span key={id} className={`lh-tile ${cls}`} style={{ backgroundImage: `url("${src}")` }} />
        ))}
        <span className="lh-note lh-note--left">
          <i /> Observation saved
        </span>
        <span className="lh-note lh-note--right">
          <i /> Shared with family
        </span>
        <span className="lh-badge">
          <svg viewBox="0 0 120 120" className="lh-badge__ring">
            <defs>
              <path id="lhRing" d="M60,60 m-46,0 a46,46 0 1,1 92,0 a46,46 0 1,1 -92,0" />
            </defs>
            <text>
              <textPath href="#lhRing">FREE TRIAL · FREE TRIAL · FREE TRIAL · </textPath>
            </text>
          </svg>
          <b>30</b>
          <small>days</small>
        </span>
      </div>
    </section>
  );
};

export default HomeHero;
